import React from "react";
import { useLocation } from "react-router-dom";

import settings from "@settings";

function Analytics(props: any) {
	const { details } = props
  const { pathname } = useLocation();

	if (!details || settings.env !== "staging") return null;

  return (
    <>
      <input hidden id="analytic_id" value={details?.cmsId} onChange={() => null} />
      <input hidden id="analytic_name" value={details?.name} onChange={() => null} />
      <input hidden id="analytic_url" value={`${settings.promotions.webUrl}${pathname}`} onChange={() => null} />
      <input hidden id="analytic_imageUrl" value={details?.imageUrl} onChange={() => null} />
      <input hidden id="analytic_description" value={details?.description} onChange={() => null} />
      <input hidden id="analytic_campaignStartDate" value={details?.scheduleFrom} onChange={() => null} />
      <input hidden id="analytic_campaignEndDate" value={details?.scheduleTo} onChange={() => null} />
      <input hidden id="analytic_brand" value={details?.vendor?.name} onChange={() => null} />
      <input hidden id="analytic_language" value={details?.language} onChange={() => null} />
      <input hidden id="analytic_category" value={JSON.stringify(details?.categories)} onChange={() => null} />
    </>
  );
}

export default Analytics;
